/* @flow */

// eslint-disable-next-line import/no-commonjs
module.exports = require('./dist/post-robot');

// eslint-disable-next-line import/no-commonjs
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/post-robot/index.js
// module id = 721
// module chunks = 0 1 2